/**
 * Brand-list helpers for selectors.
 *
 * "Company Level" (brands_v2 id 1 for company 1) is a SYNTHETIC brand, not a real
 * one — it exists so that shared connectors (banks, accounting, marketplace OAuth)
 * can be attached at the company level. It carries no real inventory/analytics data,
 * so it must NOT appear as a selectable brand in inventory brand dropdowns (it just
 * shows zeros). Consolidation is done via a dedicated "All Brands" option instead.
 *
 * Detected by name/slug (NOT a hardcoded id) so it works for every tenant — brand
 * ids are global, so a different company's "Company Level" row has a different id.
 * (Connectors render their own "Company Level" option from a platform flag and do
 * NOT rely on this list, so filtering here does not affect connector setup.)
 */
export const isCompanyLevelBrand = (brand) => {
  const name = String(brand?.name || '').trim().toLowerCase();
  const slug = String(brand?.slug || '').trim().toLowerCase();
  return name === 'company level' || slug === 'company-level';
};

export const excludeCompanyLevel = (brands = []) =>
  (brands || []).filter((b) => !isCompanyLevelBrand(b));
